import 'popper.js';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tooltip';
import {
  homeCarousel,
  verticalCarousel,
  testimonialsCarousel,
  servicesCarousel,
  offersCarousel,
  partnersCarousel
} from "./components/carousels";
import MobileNav from './components/mobilenav';
import Navigation from './components/navigation';
import Forms from './components/forms';
import GoogleMaps from './components/google-maps';

class App {
  static init() {
    homeCarousel();
    testimonialsCarousel();
    offersCarousel();
    verticalCarousel();
    servicesCarousel();
    partnersCarousel();
    (new MobileNav().init());
    (new Navigation().init());
    (new Forms()).init();
    (new GoogleMaps()).init();

    $('.js-job-modal-open').on({
      click(e) {
        e.preventDefault();
        $('.job-modal #job-title').text('');
        $('.job-modal #job-title').text($(this).data('offer'))
        $('.job-modal input[name="your-subject"]').val($(this).data('offer'));
        $('.job-modal').modal('show');
      }
    });

    if ([...document.querySelectorAll('.form-group--file')].length) {
      [...document.querySelectorAll('.form-group--file')].forEach((item) => {
        const input = $(item).find('input[type="file"]')[0];
        const label = $(item).find('label span.name');

        input.addEventListener('change', (e) => {
          const name = e.target.value.split(/\\|\//).pop();
          const truncated = name.length > 20
            ? name.substr(name.length - 20)
            : name;
          label.text(truncated)

          if (!truncated) {
            label.text(label.data('value'));
          }
        });
      });
    }

    $('[data-toggle="tooltip"]').tooltip();

    if ([...document.querySelectorAll('.js-scroll-top')].length) {
      const scrollTop = () => {
        import('smooth-scroll').then(module => {
          const SmoothScroll = module.default;
          (new SmoothScroll()).animateScroll(0);
        });
      };
      [...document.querySelectorAll('.js-scroll-top')].forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          scrollTop();
        });
      });
    }

    if ($('[lightbox-gallery]').length) {
      (async () => {
        await import('lightgallery');
        await import('lg-thumbnail');
        await import('lg-zoom');

        $('[lightbox-gallery]').each((_, item) => {
          $(item).lightGallery({
            thumbnail: true,
            selector: 'a',
            download: false,
            exThumbImage: 'data-thumb',
            subHtmlSelectorRelative: true,
          });
        });
      })();
    }

    if ([...document.querySelectorAll('.js-count')].length) {
      const options = {
        startVal: 0,
        separator: '',
      };
      import('countup.js').then(module => {
        const { CountUp } = module;
        [...document.querySelectorAll('.js-count')].forEach((item) => {
          if (!item.dataset.value) {
            return;
          }
          // eslint-disable-next-line
          (new CountUp(item, item.dataset.value, options)).start();
        });
      });
    }
  }
}

App.init();
